import { render, staticRenderFns } from "./ph-position-bar.vue?vue&type=template&id=5d50d008"
import script from "./ph-position-bar.vue?vue&type=script&lang=js"
export * from "./ph-position-bar.vue?vue&type=script&lang=js"
import style0 from "./ph-position-bar.vue?vue&type=style&index=0&id=5d50d008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports